export type ErrorContext = Record<string, unknown>;
export type ErrorContexts = Record<string, ErrorContext | undefined>;

export interface WithContext {
    readonly context?: ErrorContexts;
}

export const hasContext = (error: unknown): error is WithContext => {
    return (
        !!error &&
        typeof error === 'object' &&
        'context' in error &&
        !!error['context'] &&
        typeof error['context'] === 'object'
    );
};

export const getErrorContext = (error: unknown): ErrorContexts | undefined => {
    if (hasContext(error)) {
        return error.context;
    }

    return undefined;
};
